<template>
    <div class="m15 page_logo" ref="body" style="page-break-before: always;" v-if="completo" id="investidor">
        <div class="site"></div>
        <div class="texto" v-if="oabprev" style="padding-top: 110px">
            A OABPrev possui uma estratégia de diversificação da carteira alinhada com os objetivos da política de investimentos da entidade.
            Temos a finalidade de superar a inflação + 4% ao ano.
        </div>
        <h4 class="simulator-title loaded" :style="{'padding-top': oabprev ? '5px' : undefined}">Perfil do Investidor</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <div v-html="texto"></div>
        <br>
        <div class="row">
            <div class="col l12 s12">
                <div class="texto" style="text-align:justify; font-weight: bold;">
                    Existem mais 2 tipos de perfis de investidor:
                </div>
            </div>
        </div>
        <ol style="padding: 0">
            <li class="texto">{{outros_perfis.texto1}}</li>
            <li class="texto">{{outros_perfis.texto2}}</li>
        </ol>
    </div>
</template>

<script>
import { api } from "@/helpers/api";
import TextoHelper from "@/helpers/texto-investidor";
import Saudacao from './Saudacao'
export default {
    name: 'PerfilInvestidor',




    data () {
        return {
            texto: null,
            outros_perfis: {},
            titulo: 'Perfil do Investidor',


            relatorio: {}
        }
    },

    components: {
        Saudacao
    },

    props: {
        empresa: Object,
        cliente: {
            type: Object,
            default: null
        }
    },

    methods: {

        plot() {

            if (! this.$refs.body) return '';

            return this.$refs.body.outerHTML;
        },

        async getCliente () {

            const { data: { result: { data: relatorio } } } = await api.get(`cliente/${this.cliente.cliente_id}/relatorio-questionarios-investidor`);
            this.texto = TextoHelper.Investidor(relatorio.total)
            this.outros_perfis = TextoHelper.OutrosInvestidores(relatorio.total)


            this.relatorio = relatorio;
        }
    },

    async created () {
        await this.getCliente()
    },

    computed: {
        completo() {
            return this.relatorio.quantidade_questionarios == this.relatorio.quantidade_questionarios_respondidos
        },

        oabprev(){
            return this.empresa && this.empresa.empresa_nome_fantasia.toLowerCase().includes('oabprev')
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../relatorios/Simulador.scss";
    ol {
        li {
            margin-bottom: 20px;
            text-align: justify;
        }
    }

    ol li {
        display: flex;
        align-items: flex-start;
        counter-increment: item;
    }
    ol li:before {
        content: counter(item) " ";
        background: var(--color-primary);
        font-weight: bold;
        color:#fff;
        box-sizing: border-box;
        display: block;
        min-width: 32px;
        text-align: center;
        padding: 5px;
        margin: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/PerfilInvestidor.vue